export const FIELD_TYPES = {
    Input: 'input',
    Multiline: 'multiline',
    MultipleChoice: 'multi-choice',
    SingleChoice: 'single-choice',
};
